import React, { Component } from "react";
import anime from "animejs";
import Helmet from 'react-helmet'
import SVG from "../components/SVG";
import Menu from "../components/Menu";
import Flower from "../components/Flower";
import {
  scaleUp,
  fadeIn,
  fadeInFromLeftAndRight,
  fadeInFromRight,
  fadeOutList,
  fadeOut,
  typing,
  translateY
} from "../utils/animations";
import { Redirect } from "react-router-dom";
import Heading from "../components/Text/Heading";
import TextList from "../components/Text/TextList";
import TypingText from "../components/Text/TypingText";
import Header from "../components/Header";
import Logo from "../components/Logo";
import AnimationControls from "../components/AnimationControls";

export default class Nip extends Component {
  constructor() {
    super();
    this._isMounted = false; // Not an optimal solution.
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    this._isMounted = true;

    var controlsProgressEl = document.querySelector("#TLcontrols .progress");

    // Flower main screen animations.
    document.querySelector("#real-flower").style.display = "none";
    anime(scaleUp("#petal-nip-dupli", [1, 10], 1000));
    anime(translateY("header", [0, -100]));
    anime(fadeIn("#TLcontrols", 1000));

    // Text animations.
    const controlledTimeline = anime
      .timeline({
        easing: "linear",
        update: anim => (controlsProgressEl.value = anim.progress)
      })
      .add(fadeInFromLeftAndRight("#heading-paixnidi", 200, 1500))
      .add(fadeInFromLeftAndRight("#list-paixnidi .list-item", 500, 1500))
      .add(fadeOut("#heading-paixnidi", 1500))
      .add(fadeOutList("#list-paixnidi .list-item", 0, 200))
      .add(fadeInFromLeftAndRight("#heading-taxidi", 200, 1500))
      .add(fadeInFromLeftAndRight("#list-taxidi .list-item", 500, 2000))
      .add(fadeOut("#heading-taxidi", 1500))
      .add(fadeOutList("#list-taxidi .list-item", 0, 200))
      .add(typing("#typing-text-path-1", ["m-8,180 h0", "m-8,180 h700"], 5000))
      .add(
        typing("#typing-text-path-2", ["m130,230 h0", "m130,230 h450"], 2000)
      )
      .add(fadeInFromRight("#animated-logo"));

    document.querySelector("#TLcontrols .play").onclick =
      controlledTimeline.play;
    document.querySelector("#TLcontrols .pause").onclick =
      controlledTimeline.pause;
    document.querySelector("#TLcontrols .restart").onclick =
      controlledTimeline.restart;

    controlsProgressEl.addEventListener("input", () =>
      controlledTimeline.seek(
        controlledTimeline.duration * (controlsProgressEl.value / 100)
      )
    );

    ["input", "change"].forEach(evt =>
      controlsProgressEl.addEventListener(evt, () =>
        controlledTimeline.seek(
          controlledTimeline.duration * (controlsProgressEl.value / 100)
        )
      )
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleMenuClick() {
    if (this._isMounted)
      this.setState({ redirect: true });
  }

  render() {
    if (this.state.redirect)
      return <Redirect to={{ pathname: "/", state: { referrer: "/Nip", elementId: '#petal-nip-dupli' } }} />;
    return (
      <div>
        <Helmet
          title={"Όνειρο - Νηπιαγωγείο"}
          meta={[
            { name: 'description', content: "Όνειρο - σελίδα Νηπιαγωγείου. Το Νηπιαγωγείο είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά. Το Νηπιαγωγείο είναι 'Όνειρο'. "},
          ]}
        />
        <Header>
          <SVG
            id={"header-logo"}
            height={"48px"}
            width={"350px"}
            viewBox={"20 0 220 150"}
          >
            <Logo />
          </SVG>
        </Header>
        <Menu color={"#550055"} handleMenuClick={this.handleMenuClick} />
        <main>
          <SVG id={"flower"} viewBox={`50 -40 680 700`} fitToScreen={true}>
            <Flower page={"Nip"} />
            <Heading
              id={"heading-paixnidi"}
              content={"Το Νηπιαγωγείο είναι παιχνίδι"}
              color={"#550055"}
              fontSize={"35px"}
            />
            <TextList
              id={"list-paixnidi"}
              fontSize={"25px"}
              list={[
                "Παιχνίδι συνύπαρξης, συνεργασίας, φιλίας",
                "Παιχνίδι σκέψης",
                "Παιχνίδι γνώσης",
                "Παιχνίδι αναγνώρισης έκφρασης συναισθημάτων",
                "Παιχνίδι κίνησης",
                "Παιχνίδι δημιουργίας",
                "Παιχνίδι καλλιέργειας δεξιοτήτων",
                "Παιχνίδι αγωγής..."
              ]}
              color={"#550055"}
            />
            <Heading
              id={"heading-taxidi"}
              content={"Το νηπιαγωγείο είναι ταξίδι"}
              color={"#550055"}
              fontSize={"35px"}
            />
            <TextList
              id={"list-taxidi"}
              fontSize={"25px"}
              list={[
                "Ταξίδι φαντασίας",
                "Ταξίδι μυθοπλασίας",
                `Ταξίδι στο "παρελθόν" αλλά και στο μέλλον`,
                "Ταξίδι στον κόσμο της τέχνης",
                "Ταξίδι στον χώρο των επιστημών..."
              ]}
              color={"#550055"}
            />
            <TypingText
              number={1}
              fontSize={"24px"}
              content={
                "Το Νηπιαγωγείο είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά."
              }
              color={"#550055"}
            />
            <TypingText
              number={2}
              fontSize={"40px"}
              content={"Το Νηπιαγωγείο είναι"}
              color={"#550055"}
            />
            <g transform="scale(.8) translate(270, 310)">
              <Logo id={"animated-logo"} />
            </g>
          </SVG>
          <AnimationControls color={"burgundy"} />
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/nhpiagwgeio.js